import classNames from "classnames";

const InfoBox = ({ icon, title, description, variant = "info", className }) => (
  <div className={classNames("infoBox", `infoBox--${variant}`, className)}>
    {icon && <div className="infoBox--icon">{icon}</div>}
    <div className="infoBox--content">
      {title && <h3 className="infoBox--content__title">{title}</h3>}
      {description && (
        <div className="ac-collectif__infoBox-description">{description}</div>
      )}
    </div>
  </div>
);

export default InfoBox;
